interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
}

export default function SectionHeader({ eyebrow, title, subtitle, align = "center" }: SectionHeaderProps) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} mb-8 md:mb-10`}>
      {eyebrow && (
        <span className="mb-3 inline-flex items-center gap-2 font-label text-xs tracking-widest text-primary-600">
          <span className="h-px w-6 bg-primary-400"></span>
          {eyebrow}
          <span className="h-px w-6 bg-primary-400"></span>
        </span>
      )}
      <h2 className="font-display text-3xl md:text-4xl text-foreground-950">{title}</h2>
      {subtitle && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">{subtitle}</p>}
    </div>
  );
}